
const _settings = {
	remote: "http://ferlovmancoba.com/wp-json/wp/v2"
}


export default _settings;


// WEBPACK FOOTER //
// ./src/js/_settings.js